var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationEmptyStateNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #212529;\n      }\n\n      .cls-3 {\n        fill: #7e0386;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #eef0f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    className: "cls-5",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.73,70.95c2.62-.34,4.49-2.77,4.15-5.39l-9.53,1.24c.34,2.62,2.74,4.49,5.39,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.09,71.61c-1.19,0-2.35-.39-3.31-1.13-1.15-.88-1.88-2.16-2.07-3.6l-.08-.62,10.77-1.4,.08,.62c.39,2.97-1.72,5.7-4.69,6.09h0c-.24,.03-.48,.05-.71,.05Zm-4.01-4.28c.24,.85,.75,1.6,1.46,2.16,.88,.68,1.99,.98,3.09,.83,2.08-.27,3.6-2.03,3.64-4.06l-8.2,1.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.68,53.35l-1.55-11.92c-.95-7.32-5.66-12.93-12.69-13.67l-.21-1.62c-.26-1.98-2.06-3.37-4.04-3.11-1.98,.26-3.37,2.06-3.11,4.04l.21,1.62c-6.63,2.51-9.72,9.12-8.76,16.46l1.55,11.92-2.67,3.48c-1.31,1.7,.08,4.13,2.2,3.86l31.39-4.09c2.12-.28,2.86-2.99,1.16-4.3l-3.48-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.28,65.06c-1.07,0-2.04-.56-2.59-1.51-.63-1.09-.54-2.38,.23-3.37l2.52-3.27-1.52-11.66c-1.01-7.72,2.4-14.31,8.7-16.94l-.15-1.14c-.15-1.12,.15-2.23,.84-3.13,.69-.9,1.69-1.47,2.81-1.61,2.32-.29,4.44,1.34,4.74,3.65l.15,1.14c6.77,.93,11.75,6.43,12.75,14.15l1.52,11.66,3.27,2.52c.99,.76,1.4,1.98,1.08,3.19-.33,1.21-1.3,2.06-2.54,2.22l-31.39,4.09c-.14,.02-.27,.03-.41,.03Zm11.39-41.42c-.13,0-.26,0-.39,.03-.79,.1-1.49,.51-1.98,1.14-.48,.63-.69,1.41-.59,2.2l.27,2.11-.46,.17c-6.13,2.32-9.33,8.37-8.36,15.79l1.58,12.17-2.83,3.68c-.54,.7-.42,1.49-.13,1.99,.29,.49,.9,.99,1.76,.87l31.39-4.09c.87-.11,1.34-.75,1.49-1.31,.15-.56,.06-1.34-.63-1.87l-3.68-2.83-1.59-12.17c-.95-7.3-5.71-12.46-12.13-13.12l-.49-.05-.28-2.11c-.1-.79-.51-1.49-1.14-1.98-.52-.4-1.16-.62-1.81-.62Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 55.47,
    cy: 30.87,
    r: 3.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.46,35.25c-.76,0-1.51-.2-2.19-.59-1.01-.59-1.73-1.53-2.03-2.66s-.14-2.31,.45-3.32c.59-1.01,1.53-1.73,2.67-2.03h0c1.13-.3,2.31-.14,3.32,.45,1.01,.59,1.73,1.53,2.03,2.66,.62,2.33-.78,4.74-3.11,5.35-.37,.1-.75,.15-1.13,.15Zm0-7.76c-.29,0-.58,.04-.87,.11h0c-1.8,.48-2.88,2.33-2.4,4.13,.48,1.8,2.33,2.88,4.13,2.4,1.8-.48,2.88-2.33,2.4-4.13-.4-1.51-1.77-2.51-3.27-2.51Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateNotifications);
export default __webpack_public_path__ + "static/media/illustration_empty-state-notifications.45ade0b9864c5cdb594d8fb7a7bb6831.svg";
export { ForwardRef as ReactComponent };